// Intentionally empty: disable Next.js polyfill bundle for modern browsers.
